import { apiClient } from './client'
import type { DashboardData } from '@/types/dashboard'

export const dashboardApi = {
  get: async (): Promise<DashboardData> => {
    const { data } = await apiClient.get('/admin/dashboard')
    return data.data
  },
}
